var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGalleryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3598_1629)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 20.5H0V3.5H10.602L14 7.15788V20.5ZM4.07099 9.79614C4.66212 9.79614 5.1413 10.2804 5.1413 10.8794C5.1413 11.4771 4.66212 11.9626 4.07099 11.9626C3.48123 11.9626 3.00205 11.4771 3.00205 10.8794C3.00205 10.2804 3.48123 9.79614 4.07099 9.79614ZM8.56109 13.9133L10.4751 10.5598L10.7577 10.0659L10.9652 10.5972L12.2553 16.8006H1.97543V15.5389L2.36724 15.5251L3.08532 15.4877L3.91263 13.4388L4.4273 13.4665L4.81502 14.8472H5.75973L6.85188 11.9986L7.0471 11.4881L7.33652 11.9488L8.56109 13.9133ZM13.1235 19.5454V7.97689H10.0273V4.31763H0.888737V19.5454H13.1235Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3598_1629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 17,
    fill: "white",
    transform: "translate(0 3.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryIcon);
export default __webpack_public_path__ + "static/media/gallery_icon.927ff19551e860bed09f515c224e233c.svg";
export { ForwardRef as ReactComponent };